import React, { useCallback, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { UnknownObject } from '../../../../../../react-app-env';

import { withStyles } from '@material-ui/core';

import CustomStepper from '../../../../../../components/CustomStepper';
import { LocationUser, validationErrors, ValidationErrors, LocationUserReducerAction, LocationUserType, validation } from '../..';
import StepDetails from '../StepDetails';
import StepUserRole from '../StepUserRole';
import StepReview from '../StepReview';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>;
  completeLabel: string;
  user: LocationUser;
  isEdit?: boolean;
  pinEnabled: boolean;
  usedPins: string[];
  userTypes: LocationUserType[];
  dispatch: React.Dispatch<{ type: LocationUserReducerAction; value: any }>;
  handleSave: () => void;
}

const OrganisationUserSteps = ({ classes, completeLabel, user, isEdit = false, pinEnabled, usedPins, userTypes, dispatch, handleSave }: Props): React.ReactElement => {
  const [step, setStep] = useState<number>(0);

  const [errors, setErrors] = useState<ValidationErrors>({
    first_name: false,
    last_name: false,
    email: false,
    email_invalid: false,
    user_type: false,
    pin: false,
    pinUsed: false,
  });

  const validate = useCallback(
    (_step: number) => {
      const errorItems: UnknownObject = {};
      if (_step === 0) {
        errorItems.first_name = validation.first_name(user.first_name);
        errorItems.last_name = validation.last_name(user.last_name);
        errorItems.email = validation.email(user.email);
        errorItems.pin = validation.pin(user.pin, usedPins);
      }
      if (_step === 1) {
        errorItems.user_type = !user.user_type ? validationErrors.user_type : false;
      }
      setErrors({ ...errors, ...errorItems });
      return (Object.keys(errorItems) as Array<keyof typeof validationErrors>).some((i) => errorItems[i]);
    },
    [user, usedPins, errors]
  );

  return (
    <>
      <CustomStepper
        step={step}
        isNextDisabled={(Object.keys(errors) as Array<keyof typeof errors>).some((i) => errors[i])}
        completeLabel={completeLabel}
        setStep={setStep}
        validate={validate}
        handleComplete={handleSave}>
        {[
          {
            label: 'Details',
            component: <StepDetails user={user} isEdit={isEdit} errors={errors} pinEnabled={pinEnabled} usedPins={usedPins} setErrors={setErrors} dispatch={dispatch} />,
          },
          {
            label: 'User type',
            component: <StepUserRole user={user} userTypes={userTypes} errors={errors} setErrors={setErrors} dispatch={dispatch} />,
          },
          {
            label: 'Summary',
            component: <StepReview user={user} userTypes={userTypes} setStep={setStep} />,
          },
        ]}
      </CustomStepper>
    </>
  );
};

export default withStyles(styles)(OrganisationUserSteps);
